import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TokenStorageService } from "./token-storage.service";
import { Observable } from "rxjs";
import { AppUrlConstants } from "../constants/AppUrlConstants";

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    constructor(private http: HttpClient, private tokenStorageService: TokenStorageService) { }
    authenticate(data: any): Observable<any> {
        return this.http.post<any>(AppUrlConstants.host + AppUrlConstants.AUth_URL, data);
    }
    getUserPermissions(): Observable<any> {
        return this.http.post<any>(AppUrlConstants.host + AppUrlConstants.USER_PERMISSION_URL, null);
    }

    logout(): Observable<any> {
        return this.http.get<any>(AppUrlConstants.host + AppUrlConstants.LOGOUT_URL);
    }
    verifyOtp(data: any): Observable<any> {
        return this.http.post<any>(AppUrlConstants.host + AppUrlConstants.AUTH_URL + AppUrlConstants.VERIFY_OTP, data);
      }
      retryOtp(data: any): Observable<any> {
        return this.http.post<any>(AppUrlConstants.host + AppUrlConstants.AUTH_URL + AppUrlConstants.RETRY_OTP, data);
      }
      changePassword(data: { userName: string; otp: string; newPassword: string }): Observable<any> {
        return this.http.post<any>(
          AppUrlConstants.host + AppUrlConstants.AUTH_URL + AppUrlConstants.CHANGE_PASSOWRD,
          data
        );
      }
    isUserLoggedIn() {
        if (this.tokenStorageService.getToken()) {
            return true;
        } else {
            return false;
        }
    }
    getUserSegment() {
        return this.tokenStorageService.getSegmentId();
    }
}